<template>
  <div class="trade_area">

    <div class="summary">
      <div class="tab">
        <ul>
          <li><router-link :to="{ path: path, query : { page:page, tradeType:'SELL', status : '' } }" :class="{match_nav:true, selected : tradeType === 'SELL'}">연승을 포기합니다</router-link></li>
          <li><router-link :to="{ path: path, query : { page:page, tradeType:'BUY', status : '' } }" :class="{match_nav:true, selected :  tradeType === 'BUY'}">연승을 도전합니다</router-link></li>
        </ul>
      </div>
      <div class="cate">
        <ul>
          <li>
            <router-link :to="{ path: path, query : { page:page, tradeType:tradeType, status : '' } }" :class="{selected : !status}">전체내역 {{ totalCount }}건</router-link>
          </li>
          <!--li class="nav_item" :class="{active : status === '1' }">
            <router-link :to="{ path: path, query : { page:page, tradeType:tradeType, status : '1' } }">{{ tradeType === 'SELL' ? '판매중' : '구매중' }} ({{ readyCount }})</router-link>
          </li-->
          <!--li class="nav_item" :class="{active : status === '2' }">
            <router-link :to="{ path: path, query : { page:page, tradeType:tradeType, status : '2' } }">{{ tradeType === 'SELL' ? '판매완료' : '구매완료' }} ({{ completeCount }})</router-link>
          </li-->
          <li>
            <router-link :to="{ path: path, query : { page:page, tradeType:tradeType, status : 'my' } }" :class="{selected : status === 'my' }">나의 참여내역 {{ myCount }}건</router-link>
          </li>
        </ul>
      </div>
    </div>


    <div class="trade_list">
      <div class="thead">
        <div class="cell no">번호</div>
        <div class="cell subject">연승내역</div>
        <div class="cell pay">희망골드</div>
        <div class="cell user">등록자</div>
        <div v-if="status === 'my'" class="cell user">{{ tradeType === 'SELL' ? '구매자' : '판매자' }}</div>
        <div class="cell date">등록일</div>
        <div class="cell option">선택</div>
      </div>
      <div v-if="list.length || !loaded" class="tbody">
        <trade-item
          v-for="(value, index) in list"
          :item="value"
          :no="(totalCount - (page - 1) * pageSize) - index"
          :status="status"
          :key="index">
        </trade-item>
      </div>
      <div v-else class="no_history">
        내역이 없습니다
      </div>
    </div>
    <trade-popup></trade-popup>
    <trade-regist></trade-regist>

    <pagenation
      :total-count="totalEntries"
      :page-size="pageSize"
      :page="page"
      :condition="condition"
      v-show="list.length && loaded"
    ></pagenation>

    <button id="register_btn" class="btn_register" v-on:click="openPopup">{{ tradeTypeText }} 등록</button>
  </div>
</template>

<script>
  import tradeItem from './trade-item'
  import tradePopup from './trade-popup'
  import tradeRegist from './trade-regist'
  import pagenation from '../pagenation'
  import common from '../../mixins/common';

  export default {
    name: 'trade-wrap',
    components: {
      tradeItem,
      tradePopup,
      tradeRegist,
      pagenation
    },
    mixins: [
      common
    ],
    data() {
      return {
        loaded: false,
        page: this.$route.query.page ? this.$route.query.page : 1,
        totalCount: 0,
        totalEntries : 0,
        totalPage: 1,
        pageSize: 10,
        list: [],
        isTabSelect: false,
        isPopup: false,
        status: this.$route.query.status ? this.$route.query.status : null,
        path: this.$route.path,
        tradeType: this.$route.query.tradeType ? this.$route.query.tradeType : 'SELL',
        myCount: 0
      }
    },
    created() {
      this.getList();
      this.$eventBus.$on("changeLIstItem", this.changeLIstItem);
    },
    methods: {
      async getList() {

        let res = await this._get("/v1/trade", {
          page: this.page,
          tradeType: this.tradeType,
          status: this.status,
        })
        let data = res.data;
        this.list = data.data;
        this.loaded = true;
        if (!this.status) {
          this.totalCount = data.totalCount;
        }
        this.totalEntries = data.totalEntries;
        this.pageSize = res.data.pageSize;
        this.totalPage = data.totalPage;
        this.page = data.page;
        this.myCount = data.myCount;
      },
      openPopup() {
        this.$eventBus.$emit("openPopup");
        $('._layer_background').show();
      },
      changeLIstItem() {
        this.getList();
      }
    },
    watch: {
      '$route'(to, from) {
        this.page = to.query.page ? parseInt(to.query.page) : 1;
        this.tradeType = to.query.tradeType ? to.query.tradeType : 'SELL';
        this.status = to.query.status ? to.query.status : null;
        this.getList();
      }
    },
    computed: {
      condition() {
        return {
          tradeType: this.tradeType,
          status: this.status,
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/store/trade-wrap.vue